import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { createForm } from 'rc-form';
import { useSelector } from 'react-redux';
import { Grid, Button, Typography } from '@material-ui/core';

import { stripPath } from 'yeself-common/utils/UrlUtils';

import { selectApplicationName } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormInput from 'Console/components/common/form/FormInput';
import FormSelect from 'Console/components/common/form/FormSelect';

import { selectApplications } from 'Console/data/applications/selectors';
import { validateUrlAddress, validateDomain } from 'Console/utils/formUtils';

const styles = (theme) => ({
    publishOptionsWrapper: {
        marginTop: theme.typography.pxToRem(10),
        marginBottom: theme.typography.pxToRem(35),
    },
    buttonsWrapper: {
        marginTop: theme.typography.pxToRem(36),
    },
    title: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 600,
        paddingBottom: theme.typography.pxToRem(15),
    },
    input: {
        flexBasis: '30%',
        marginRight: '3%',
        overflow: 'hidden',
    },
});

const sortApplicationList = (appList) => appList.sort((a, b) => a.name.localeCompare(b.name));

const PublishGuideForm = ({
    form,
    form: { getFieldsValue, getFieldsError },
    intl,
    guide,
    classes,
    onPublish,
    onCancel,
}) => {
    const formErrors = Object.values(getFieldsError()).filter((error) => error);
    const formValues = Object.values(getFieldsValue()).filter((value) => value);

    const applicationName = useSelector(selectApplicationName);
    const applicationsList = useSelector(selectApplications);

    return (
        <Grid container className={classes.publishOptionsWrapper}>
            <Grid item xs={12}>
                <Typography className={classes.title}>
                    {intl.formatMessage({
                        id: 'Guides.publishToDifferentEnv',
                    })}
                </Typography>
            </Grid>

            <Grid item className={classes.input}>
                <FormInput
                    isRequired
                    fullWidth
                    form={form}
                    type="text"
                    initialValue={guide.initialUrl?.length > 0 ? stripPath(guide.initialUrl) : ''}
                    validateTrigger="onChange"
                    formItemKey="host"
                    label={intl.formatMessage({
                        id: 'Guides.oldDomainName',
                    })}
                    placeholder={intl.formatMessage({
                        id: 'Guides.oldDomainName',
                    })}
                    additionalRules={[
                        {
                            validator: validateDomain,
                        },
                    ]}
                />
            </Grid>

            <Grid item className={classes.input}>
                <FormInput
                    isRequired
                    fullWidth
                    form={form}
                    type="text"
                    validateTrigger="onChange"
                    label={intl.formatMessage({
                        id: 'Guides.newDomainName',
                    })}
                    formItemKey="newHost"
                    placeholder={intl.formatMessage({
                        id: 'Guides.newDomainName',
                    })}
                    additionalRules={[
                        {
                            validator: validateDomain,
                        },
                    ]}
                />
            </Grid>

            <Grid item className={classes.input}>
                <FormSelect
                    isRequired
                    form={form}
                    fullWidth
                    formItemKey="application"
                    initialValue={sortApplicationList(applicationsList).find(
                        (option) => option.name === applicationName
                    )}
                    label={intl.formatMessage({ id: 'Guides.selectApplication' })}
                    optionList={sortApplicationList(applicationsList)}
                />
            </Grid>

            <Grid className={classes.buttonsWrapper} container justify="flex-end">
                <Button
                    id="yeself-cancel-button"
                    style={{ color: 'rgba(0, 0, 0, 0.38)', marginRight: '19px' }}
                    onClick={onCancel}
                >
                    {intl.formatMessage({
                        id: 'Buttons.cancel',
                    })}
                </Button>

                <Button
                    id="yeself-button"
                    disabled={formErrors.length > 0}
                    variant="contained"
                    color="primary"
                    onClick={onPublish(getFieldsValue())}
                >
                    {intl.formatMessage({
                        id: 'Buttons.publish',
                    })}
                </Button>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(createForm()(injectIntl(PublishGuideForm)));
